import { observable, computed, action, makeObservable, } from 'mobx';
import { html } from 'lit';
export default class OcclStore {
    constructor(occlUri, styleContext) {
        this.occlVersion = 'v3';
        this.themeLoaded = false;
        this.vendorsLoaded = false;
        this.bundleLoaded = false;
        this.error = undefined;
        this.$loadScript = (options) => {
            const { src, module, namespace, onLoad = () => { }, onError = () => { }, } = options;
            const script = document.createElement('script');
            script.setAttribute('src', src);
            if (module) {
                script.setAttribute('type', 'module');
            }
            else {
                script.setAttribute('nomodule', '');
            }
            if (namespace) {
                script.setAttribute('namespace', namespace);
            }
            script.addEventListener('load', onLoad);
            script.addEventListener('error', onError);
            document.body.appendChild(script);
        };
        makeObservable(this, {
            themeLoaded: observable,
            vendorsLoaded: observable,
            bundleLoaded: observable,
            error: observable,
            ready: computed,
            loadScripts: action,
            renderStylesheet: action,
        });
        this.occlUri = occlUri;
        this.styleContext = styleContext;
        this.loadScripts();
    }
    get ready() {
        return this.themeLoaded && this.vendorsLoaded && this.bundleLoaded;
    }
    loadScripts() {
        const onLoadVendors = action(() => { this.vendorsLoaded = true; });
        const onLoadBundle = action(() => { this.bundleLoaded = true; });
        const onError = () => { this.error = new Error('loading OCCL failed'); };
        const scripts = [{
                src: `${this.occlUri}/${this.occlVersion}/library/vendors.js`,
                module: true,
                onLoad: onLoadVendors,
                onError,
            }, {
                src: `${this.occlUri}/${this.occlVersion}/library/vendors-es5.js`,
                module: false,
                onLoad: onLoadVendors,
                onError,
            }, {
                src: `${this.occlUri}/${this.occlVersion}/pre-sets/coms/bundle.js`,
                module: true,
                namespace: 'coms',
                onLoad: onLoadBundle,
                onError,
            }, {
                src: `${this.occlUri}/${this.occlVersion}/pre-sets/coms/bundle-es5.js`,
                module: false,
                namespace: 'coms',
                onLoad: onLoadBundle,
                onError,
            }];
        scripts.forEach((script) => this.$loadScript(script));
    }
    renderStylesheet() {
        const themeUri = `${this.occlUri}/${this.occlVersion}/pre-sets/coms/bundle.css`;
        const onLoad = action(() => { this.themeLoaded = true; });
        const onError = action(() => { this.error = new Error('loading OCCL failed'); });
        return html `
      <link rel="stylesheet" href="${themeUri}" @load="${onLoad}" @error="${onError}" />
    `;
    }
    getStyleContextClasses() {
        return this.styleContext
            ? this.styleContext.split(' ').filter((s) => s).map((s) => `context-${s}`)
            : [];
    }
}
//# sourceMappingURL=OcclStore.js.map